import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    menu: false,
    language: 'en'
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        toggleMenu: (state, action) => {
            state.menu = action.payload;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
        }
    }
});

export const { actions, reducer } = appSlice;